export const HDMS_SCOPE_CLASSES = ['hdms', 'hdms-reset'];
